<template>
	<div class="container">
		<div class="row">
			<div class="col-6">
				<h1>Panel</h1>
				<hr>
			</div>
			<div class="col-6">
				<Panel text="Lorem ipsum dolor sit amet consectetur, adipisicing elit. <b>Maiores, repellendus doloremque tempore perferendis mollitia aut perspiciatis enim quae iusto error.</b>"></Panel>
			</div>
			<div class="col-6">
				<Panel link="#" linkText="En savoir plus" text="Lorem ipsum dolor sit amet consectetur, adipisicing elit. <b>Maiores, repellendus doloremque tempore perferendis mollitia aut perspiciatis enim quae iusto error.</b>"></Panel>
			</div>
			<div class="col-6">
				<Panel secondary="true" link="#" linkText="En savoir plus" text="Lorem ipsum dolor sit amet consectetur, adipisicing elit. <b>Maiores, repellendus doloremque tempore perferendis mollitia aut perspiciatis enim quae iusto error.</b>"></Panel>
			</div>
		</div>
	</div>
</template>

<script>
import Panel from '@/components/content/Panel.vue';

export default {
	components: {
		Panel,
	},
};
</script>
